<style>
.comment-review-container {
  --taco-height: 22px;
  --taco-width: 150px;
}
</style>

<template>
  <div class="comment-review-container row mb-3">
    <div
      class="col-12 col-md-6"
      :class="{ 'title-invalid': !isValid}"
    >
      <div class="d-flex">
        <label class="mr-1" for="title">Title</label>
        <!-- eslint-disable-next-line vue-a11y/label-has-for -->
        <label class="error-text">Please enter a title</label>
      </div>
      <div>
        <!-- eslint-disable-next-line vue-a11y/form-has-label -->
        <input
          id="title"
          type="text"
          placeholder="Enter your title"
          class="form-control p-2"
          :value="title"
          maxlength="255"
          @input="onInputChange"
        >
      </div>
    </div>
    <div class="col-12 col-md-6 mt-3 mt-md-0 pl-3 pl-md-5">
      <div class="d-flex">
        <!-- eslint-disable-next-line vue-a11y/label-has-for -->
        <label>Click to provide your taco rating</label>
      </div>
      <div
        class="appsumo-taco-container flex-wrap"
        data-testid="taco-rating"
      >
        <div class="taco-rating">
          <span
            class="taco-rating-pct"
            :style="ratingStyle"
          />
          <!-- eslint-disable vue-a11y/mouse-events-have-key-events -->
          <span
            v-for="(classname, index) in tacoClasses"
            :key="classname"
            class="taco-click"
            :class="classname"
            :data-testid="classname"
            @click="onClickTaco(index + 1)"
            @mouseenter="onMouseEnter(index + 1)"
            @mouseleave="onMouseLeave"
          />
          <!-- eslint-enable vue-a11y/mouse-events-have-key-events -->
        </div>
        <div class="pl-3">
          <LegacyDropdown
            highlight
            container-style="min-width: 90px"
            button-style="padding: 10px 30px 10px 10px;"
            :value="rating"
            :options="ratingsList"
            @selected="onClickDropdown"
          >
            {{ dropdownLabel }}
          </LegacyDropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';
// TODO:BRO-1276: import DDropdownItem from '@appsumo/dorado-nuxt';
import LegacyDropdown from '../../ui/LegacyDropdown.vue';

export default {
  name: 'PDPCommentReview',
  components: {
    LegacyDropdown,
  },
  props: {
    isValid: {
      type: Boolean,
    },
    rating: {
      type: Number,
      default: 5,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      hoverRating: -1,
      ratingsList: [
        { value: 5, display: '5 tacos' },
        { value: 4, display: '4 tacos' },
        { value: 3, display: '3 tacos' },
        { value: 2, display: '2 tacos' },
        { value: 1, display: '1 taco' },
      ],
      tacoClasses: [
        'taco-click-1',
        'taco-click-2',
        'taco-click-3',
        'taco-click-4',
        'taco-click-5',
      ],
    };
  },
  computed: {
    ratingStyle() {
      const IMG_WIDTH = 32;

      let style = {
        width: `${this.rating * IMG_WIDTH}px`,
      };

      if (this.hoverRating > -1) {
        style = {
          width: `${this.hoverRating * IMG_WIDTH}px`,
          filter: 'contrast(1.3)',
        };
      }

      return style;
    },
    dropdownLabel() {
      return get(this.ratingsList, [Math.abs(this.rating - 5), 'display'], this.rating);
    },
  },
  methods: {
    onClickTaco(index) {
      this.$emit('update-rating', index);
    },

    onClickDropdown({ value }) {
      this.onClickTaco(value);
    },

    onMouseEnter(index) {
      this.hoverRating = index;
    },

    onMouseLeave() {
      this.hoverRating = -1;
    },

    onInputChange(e) {
      this.$emit('on-change-title', e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
  input {
    width: 100%;

    &::placeholder {
      font-size: 0.9rem;
      opacity: 0.8;
      color: #6c757d;
    }
  }

  label {
    font-size: 1rem;
  }

  .taco-rating {
    height: var(--taco-height);
    width: var(--taco-width);
    position: relative;
    top: -1px;
  }

  .taco-rating::before { /* no ratings */
    background-image: url(../../../../static/images/tacos/as-taco-0.svg);
    background-repeat: no-repeat;
    background-size: var(--taco-width);
    height: var(--taco-height);
    width: var(--taco-width);
    position: absolute;
    top: 2px;
    bottom: 0;
    left: 0;
    right: 0;
    content: '';
  }

  .taco-rating-pct {
    display: block;
    height: var(--taco-height);
    width: var(--taco-width);
    position: absolute;
    overflow: hidden;
    transition: all 50ms ease-in-out;
  }

  .taco-rating-pct::before { /* active */
    background-image: url(../../../../static/images/tacos/as-taco-5.svg);
    background-repeat: no-repeat;
    background-size: var(--taco-width);
    height: var(--taco-height);
    top: 2px;
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    content: '';
  }

  .taco-rating-text {
    padding-left: 10px;
  }

  .appsumo-taco-container {
    display: flex;
    align-items: center;
  }

  .appsumo-review-decimal {
    font-weight: 600;
    margin: 0 10px 0 8px;
  }

  // Make each target area a little larger than the taco
  .taco-click {
    position: absolute;
    height: 32px;
    width: 32px;
    z-index: 2;
    cursor: pointer;
    top: -4px;
  }

  .taco-click-1 {
    left: -4px;
  }

  .taco-click-2 {
    left: 28px;
  }

  .taco-click-3 {
    left: 60px;
  }

  .taco-click-4 {
    left: 92px;
  }

  .taco-click-5 {
    left: 124px;
  }

  .error-text {
    display: none;
  }

  .title-invalid {
    .form-control {
      border-color: #dc3545;
      box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
    }

    .error-text {
      display: block;
      color: #dc3545;
    }
  }
</style>
